import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-case-studies',
  standalone: true,
  imports: [RouterLink, NgFor],
  template: `
  <section class="stack">
    <article class="card about">
      <div class="card__head">
        <h2 class="h2">À propos</h2>
        <a class="miniLink" routerLink="/about">Voir →</a>
      </div>

      <p class="muted">
        La data au service de décisions <span class="accent">business</span>.
      </p>

      <div class="subcard">
        <div class="subttl">Notre Mission</div>
        <div class="subtxt">Créer de la valeur avec la data</div>
      </div>

      <div class="icons">
        <div class="ic"><span>📌</span><small>Stratégie</small></div>
        <div class="ic"><span>🧾</span><small>Data</small></div>
        <div class="ic"><span>⚡</span><small>Impact</small></div>
      </div>
    </article>

    <article class="card services">
      <div class="card__head">
        <h2 class="h2">Services</h2>
        <a class="miniLink" routerLink="/services">Voir →</a>
      </div>

      <div class="svc" *ngFor="let s of services">
        <span class="badge">{{s.icon}}</span>
        <div>
          <div class="svc__t">{{s.title}}</div>
          <div class="svc__d">{{s.desc}}</div>
        </div>
      </div>
    </article>

    <article class="card blog">
      <div class="card__head">
        <h2 class="h2">Blog</h2>
        <a class="miniLink" routerLink="/blog">Tous →</a>
      </div>

      <div class="posts">
        <a class="post" routerLink="/blog" *ngFor="let p of posts">
          <div class="thumb"></div>
          <div class="meta">
            <div class="pt">{{p}}</div>
            <div class="pd">Insights & bonnes pratiques</div>
          </div>
        </a>
      </div>

      <a class="btn sm ghost full" routerLink="/blog">Voir tous les articles</a>
    </article>

    <article class="card careers">
      <div class="card__head">
        <h2 class="h2">Carrières</h2>
        <a class="miniLink" routerLink="/careers">Voir →</a>
      </div>

      <p class="muted">Rejoignez notre équipe</p>

      <div class="jobs">
        <a class="job" routerLink="/careers" *ngFor="let j of jobs">{{j}}</a>
      </div>

      <a class="btn sm primary full" routerLink="/careers">Voir nos postes ouverts</a>
    </article>
  </section>
  `,
  styles: [`
    .stack{ display:flex; flex-direction:column; gap: 16px; }

    .card{
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.03);
      padding: 16px;
      box-shadow: 0 30px 120px rgba(0,0,0,.45);
      position:relative;
      overflow:hidden;
    }
    .card::before{
      content:"";
      position:absolute; inset:-60px;
      background:
        radial-gradient(circle at 18% 22%, rgba(79,125,255,.22), transparent 55%),
        radial-gradient(circle at 84% 28%, rgba(0,229,168,.16), transparent 58%),
        radial-gradient(circle at 60% 92%, rgba(168,85,247,.12), transparent 60%);
      opacity:.55;
      pointer-events:none;
    }

    .card__head{ display:flex; align-items:flex-end; justify-content:space-between; gap:10px; position:relative; }
    .miniLink{ color: rgba(235,240,255,.75); font-weight: 900; padding: 8px 10px; border-radius: 12px; border: 1px solid rgba(255,255,255,.10); background: rgba(255,255,255,.04); }
    .muted{ margin: 10px 0 0; color: rgba(235,240,255,.72); font-weight: 750; position:relative; }
    .accent{ color: rgba(0,229,168,.95); font-weight: 1000; }

    .subcard{
      margin-top: 12px;
      border-radius: 18px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      padding: 12px;
      position:relative;
    }
    .subttl{ color: rgba(235,240,255,.82); font-weight: 950; font-size: 13px; }
    .subtxt{ margin-top: 6px; color: rgba(235,240,255,.70); font-weight: 750; }

    .icons{ display:flex; gap: 10px; margin-top: 12px; position:relative; }
    .ic{
      flex:1;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      padding: 10px 10px;
      text-align:center;
    }
    .ic span{ font-size: 18px; }
    .ic small{ display:block; margin-top: 6px; color: rgba(235,240,255,.70); font-weight: 850; }

    .svc{
      display:flex; gap: 10px;
      padding: 10px;
      border-radius: 18px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      margin-top: 10px;
      position:relative;
    }
    .badge{
      width:40px; height:40px; display:grid; place-items:center;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      box-shadow: 0 16px 50px rgba(0,0,0,.35);
    }
    .svc__t{ color: rgba(235,240,255,.90); font-weight: 950; }
    .svc__d{ margin-top: 4px; color: rgba(235,240,255,.68); font-weight: 750; font-size: 12px; }

    .posts{ margin-top: 10px; display:grid; gap: 10px; position:relative; }
    .post{
      display:flex; gap: 10px; align-items:center;
      padding: 10px;
      border-radius: 18px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
    }
    .thumb{
      width: 56px; height: 40px;
      border-radius: 14px;
      background:
        radial-gradient(circle at 30% 30%, rgba(79,125,255,.55), transparent 60%),
        radial-gradient(circle at 70% 60%, rgba(0,229,168,.35), transparent 60%),
        rgba(255,255,255,.04);
      border: 1px solid rgba(255,255,255,.10);
    }
    .pt{ color: rgba(235,240,255,.86); font-weight: 900; font-size: 13px; }
    .pd{ color: rgba(235,240,255,.62); font-weight: 750; font-size: 12px; margin-top: 3px; }

    .jobs{ margin-top: 10px; display:grid; gap: 10px; position:relative; }
    .job{
      display:block;
      padding: 10px 12px;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      color: rgba(235,240,255,.82);
      font-weight: 900;
    }

    .full{ width: 100%; margin-top: 12px; justify-content:center; }

    @media (max-width: 980px){
      .stack{ margin-top: 2px; }
    }
  `]
})
export class CaseStudiesComponent {
  services = [
    { icon: '📊', title: 'Data Analytics', desc: 'KPI, reporting, storytelling' },
    { icon: '📈', title: 'BI & Viz', desc: 'Dashboards & gouvernance KPI' },
    { icon: '🧠', title: 'Data Science & IA', desc: 'Forecasting, ML, ROI' },
    { icon: '⚙️', title: 'Data Engineering', desc: 'Pipelines ETL/ELT, DWH' },
  ];

  posts = [
    '5 KPI Clés',
    'Forecasting IA',
    'Qualité Data',
  ];

  jobs = ['Data Analyst', 'Business Analyst', 'Data Scientist', 'Data Engineer'];
}
